import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import { UploadList, UploadPreview } from 'src/components/Upload'
import DeleteConfirmation from 'src/modals/DeleteConfirmation/index'

import Modal from 'src/components/Modal/Modal'

import { getBodyContainer, setLoginToken } from 'src/utils/helpers'
import { getRequest } from 'src/utils/request-client'
import withToast from 'src/components/Toast'

import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from './translations'
import intlMessagesClaims from '../translations'

class Pictures extends Component {
  state = {
    uploading: false,
    fileToPreview: null,
    fileToDelete: null,
  }

  onBeforeUpload = () => {
    this.props.setSendingData(true)
    this.setState({
      uploading: true,
      previewVisible: false,
      previewImage: '',
    })
  }

  onFileAdded = data => {
    const { intl, toast } = this.props

    this.props.setSendingData(false)
    this.setState({ uploading: false })

    if (!(data && data.hasOwnProperty('id') && data.hasOwnProperty('url'))) {
      toast({
        title: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessagesApp.picturesUploadFailed),
        status: 'warning',
      })
      return false
    }

    this.props.addPicture({
      uid: data.id,
      url: data.url,
    })
  }

  onError = async (error, serverError) => {
    this.props.setSendingData(false)
    const { intl, toast } = this.props
    if (error.status === 401) {
      const getToken = await getRequest({ base: '/tokens/renew', mock: false }).then(
        ({ token }) => token,
      )
      setLoginToken(getToken)
    } else if (error.status === 403) {
      toast({
        title: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessagesApp.picturesUploadFailedWrongFileType),
        status: 'warning',
      })
    } else {
      toast({
        title: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description:
          serverError && serverError.error
            ? serverError.error
            : intl.formatMessage(intlMessagesApp.picturesUploadFailed),
        status: 'warning',
      })
    }

    this.setState({
      uploading: false,
    })
  }

  onRemove = item => {
    this.props.removePicture(item.uid)
  }
  filePreview = (e, file) => {
    e.preventDefault()

    this.setState({
      fileToPreview: file,
    })
  }

  filePreviewClose = () => {
    this.setState({
      fileToPreview: null,
    })
  }
  renderPreviewContent = fileToPreview => {
    const { isWidgetState } = this.props

    return (
      <UploadPreview
        isWidget={isWidgetState}
        file={fileToPreview}
        files={this.props.pictures}
        onDelete={this.fileDeletePrompt}
        onCancel={this.filePreviewClose}
      />
    )
  }
  fileDeletePrompt = file => {
    this.setState({
      fileToDelete: file,
    })
  }

  fileDelete = file => {
    if (!file) {
      return false
    }

    this.fileDeleteClose()
    this.filePreviewClose()
    this.onRemove(file)
  }

  fileDeleteClose = () => {
    this.setState({
      fileToDelete: null,
    })
  }

  render() {
    const { pictures, intl } = this.props

    return (
      <Layout className='m-claims-pictures'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.picturesHeadline)}
            subtitle={intl.formatMessage(intlMessagesClaims.claimsFillOutTheForm)}
          />
          <Container small padder>
            <div className='clearfix'>
              <UploadList
                isWidget={this.props.isWidgetState}
                itemPreviewOnly={false}
                files={pictures}
                addText={intl.formatMessage(intlMessagesApp.picturesAddPhoto)}
                onFileAdded={this.onFileAdded}
                onFileDelete={this.onRemove}
                onFilePreview={this.filePreview}
                size={true}
                dropZoneOptions={{
                  onDropHandlerUrl: `/files/upload`,
                  supportedUploadTypes: [
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'image/gif',
                    'image/svg',
                  ],
                }}
              />
            </div>
            <Modal
              isOpen={this.state.fileToPreview}
              isCentered
              footer={null}
              onOk={this.submitModal}
              onClose={() => this.setState({ fileToPreview: null })}
              renderContent={() => this.renderPreviewContent(this.state.fileToPreview)}
              getContainer={() => getBodyContainer()}
              hideFooter={true}
              closable
            ></Modal>
            <DeleteConfirmation
              icon={['far', 'trash-can']}
              heading={`${intl.formatMessage(intlMessagesApp.appGlobalDelete)} photo`}
              confirmText={intl.formatMessage(intlMessagesApp.appGlobalDelete)}
              visible={this.state.fileToDelete}
              onClose={this.fileDeleteClose}
              renderContent={() => <></>}
              onConfirm={() => this.fileDelete(this.state.fileToDelete)}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(withToast(Pictures))
